import React from 'react';

export interface AddNewProps {
    children: any;
    onClick: any;
}

const AddNew = ({children, onClick}: AddNewProps) => {
    return (
        <div className={'add-new'} onClick={() => onClick()}>
            {children}
        </div>
    )
}

export default AddNew;
